import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ConditionQuestionSet } from './good-canna-v2-conditions';
import {
  SubQuestionText,
  FollowUpQuestionText,
  FollowUpOptionsGroup,
  FollowUpOptionLabel,
} from './good-canna-v2-styles';

type ConditionFollowUpsProps = {
  conditionQuestionSet: ConditionQuestionSet;
};

// Answer options are indexed (0, 1, 2...) to match GoodCanna's index-based
// `disease_question_answers` submission format.
export const ConditionFollowUps = ({ conditionQuestionSet }: ConditionFollowUpsProps): JSX.Element => {
  const { control, formState } = useFormContext();

  return (
    <>
      {conditionQuestionSet.questions.map((followUpQuestion) => {
        const hasError = !!formState.errors[followUpQuestion.id];

        return (
          <React.Fragment key={followUpQuestion.id}>
            <SubQuestionText>{followUpQuestion.subQuestion}</SubQuestionText>
            <FollowUpQuestionText>{followUpQuestion.question}</FollowUpQuestionText>
            <Controller
              name={followUpQuestion.id}
              control={control}
              defaultValue=''
              render={({ value, onChange }) => (
                <FollowUpOptionsGroup>
                  {followUpQuestion.options.map((option, index) => (
                    <FollowUpOptionLabel
                      key={option}
                      selected={value === String(index)}
                      hasError={hasError}
                      onClick={() => onChange(String(index))}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onChange(String(index));
                        }
                      }}
                      tabIndex={0}
                      role='button'
                    >
                      {option}
                    </FollowUpOptionLabel>
                  ))}
                </FollowUpOptionsGroup>
              )}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};
